// see R.behaviors.diagram_editor.versionHistory.displayShaLengthInDigits
const displayShaLengthInDigits = 8;
export function getDisplayed5DigitChangeId(actionUid, addHashtag = true) {
    if (actionUid) {
        if (addHashtag) {
            return "#" + actionUid.substring(0, displayShaLengthInDigits);
        }
        else {
            return actionUid.substring(0, displayShaLengthInDigits);
        }
    }
    return actionUid;
}
//# sourceMappingURL=Create5Digits.js.map